const apiConfig = {
  endpoints: {
    quizService: {
      baseURL: process.env.NEXT_PUBLIC_MI_QUIZ_API_URL,
      routes: {
        getQuestions: "/mi/questions",
        createQuiz: "/mi/quiz/create",
        submitQuiz: "/mi/quiz/submit"
      }
    },
    contactService: {
      baseURL: process.env.NEXT_PUBLIC_MI_CONTACT_API_URL,
      routes: {
        contactForm: "/api/contact",
        newsletterSubscribe: "/api/subscribe/newsletter",
        jobsSubscribe: "/api/subscribe/jobs",
        businessSubscribe: "/api/subscribe/business",
        JobsRequest: "/api/jobs/job-request",
        BusinessRequest: "/api/business/business-request"
      }
    },
    blogService: {
      baseURL: process.env.NEXT_PUBLIC_BLOG_API_URL,
      routes: {
        getPosts: "/posts",
        getCategories: "/categories",
        createComment: "/comments",
        getComments: "/comments",
      }
    },
    jobService: {
      baseURL: process.env.NEXT_PUBLIC_MI_JOB_API_URL,
      routes: {
        getJobs: "/api/jobs",
        getTags: "/api/tags",
        postJob: "/api/post-job"
      }
    },
    businessService: {
      baseURL: process.env.NEXT_PUBLIC_MI_BUSINESS_API_URL,
      routes: {
        createBusiness: "/business/create",
        getBusiness: "/business/api/business",
        getCategories: "/business/categories",
        getServices: "/business/services",
        getServicesByCategory: "/business/categories/:categoryId/services"
      }
    },
    adsService: {
      baseURL: process.env.NEXT_PUBLIC_ADS_API_URL,
      routes: {
        trackClick: "/api/ads/click",
        getCatalog: "/api/ads/catalog",
        getSummary: "/api/ads/summary",
        getTopIps: "/api/ads/top-ips",
      },
    },

  }
};

export default apiConfig;
